import React from 'react';
import { navigate } from '@reach/router';
import { Box, Flex } from '@rebass/grid';
import { Dropdown, Tooltip } from 'freemium-ui';
import { Field } from 'formik';
import Icons from 'components/Icons';
import { AppConsumer } from 'shared/Application/app-context';
import { useTranslation } from 'react-i18next';
import FieldLabel from '../FieldLabel';

export const SourceLabelInfo = () => {
  const { t } = useTranslation();
  const routeToSourceManage = () => {
    navigate('/admin/settings/source');
  };
  return (
    <AppConsumer>
      {({ user }) => (
        <span style={{ top: '3px', position: 'relative', paddingLeft: '5px' }}>
          <Tooltip
            theme="light"
            label={t('components.createIncident.manageEditMessage')}
            position="top-start"
            html={
              <Box py="1">
                <div style={{ marginBottom: '8px', lineHeight: 1.4 }}>
                  {t('components.createIncident.manageEditMessage')}
                </div>

                {user && user.role !== 'ED' ? (
                  <>
                    <div style={{ margin: '5px 0' }} />
                    <Flex alignItems="center" justifyContent="flex-start">
                      <button
                        type="button"
                        style={{
                          borderRadius: '4px',
                          background: '#282a821f',
                          padding: '5px 10px',
                          color: 'rgb(4,21,56)',
                          cursor: 'pointer'
                        }}
                        onClick={routeToSourceManage}
                      >
                        Manage
                      </button>
                    </Flex>
                  </>
                ) : null}
              </Box>
            }
          >
            <Icons size={14} viewBox="0 0 14 14" glyph="setting-info" />
          </Tooltip>
        </span>
      )}
    </AppConsumer>
  );
};

type IncidentSourceProps = {
  items: any
};

const IncidentSource = (props: IncidentSourceProps) => {
  const { items: incidentSources } = props;
  const { t } = useTranslation();
  return (
    <>
      <Field name="source">
        {({ form }) => (
          <>
            <FieldLabel
              name="source"
              label="Source"
              labelInfo={<SourceLabelInfo />}
              tipTxt={t('components.createIncident.manageEditMessage')}
              tipPosition="top-start"
            />
            <Dropdown
              name="incidentSource"
              defaultSelectedItem={null || form.values.source}
              items={[
                ...(form.values.source ? [{ id: 0, value: '--' }] : []),
                ...(incidentSources || [])
              ]}
              itemToString={item => (item ? item.value : null)}
              placeholder={t('components.createIncident.selectSource')}
              onChange={item =>
                form.setFieldValue('source', item.id ? item : null)
              }
            />
          </>
        )}
      </Field>
    </>
  );
};

export default IncidentSource;
